export default __webpack_public_path__ + "static/media/CarDetailingMediumCut.2f0740d4.jpg";